<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Enhanced Header Section - Style moderne -->
      <div class="page-header modern-header" style="background-color: #255EFF;">
        <div class="header-content">
          <div class="page-title-section">
            <div class="title-wrapper">
              <div class="icon-wrapper">
                <i class="fas fa-users"></i>
              </div>
              <div class="title-content">
                <h4 class="page-title">Gestion des clients</h4>
                <p class="page-subtitle">Gérez vos clients</p>
              </div>
            </div>
          </div>
          <div class="header-actions">
            <div class="export-actions">
              <button class="action-btn export-btn" @click="exportToExcel" data-bs-toggle="tooltip"
                title="Exporter en Excel">
                <i class="fas fa-file-excel"></i>
              </button>
              <button class="action-btn export-btn" @click="exportToCSV" data-bs-toggle="tooltip"
                title="Exporter en CSV">
                <i class="fas fa-file-csv"></i>
              </button>
              <button class="action-btn export-btn" @click="exportToPDF" data-bs-toggle="tooltip"
                title="Exporter en PDF">
                <i class="fas fa-file-pdf"></i>
              </button>
            </div>
            <!-- <div class="page-btn">
              <router-link to="/addclient" class="btn btn-added">
                <i class="fas fa-plus-circle me-2"></i>
                Ajouter Nouveau Client
              </router-link>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Enhanced Filter Card -->
      <div class="card filter-card">
        <div class="card-header">
          <h6 class="card-title mb-0">
            <i class="fas fa-filter me-2"></i>
            Recherche
          </h6>
          <button class="btn btn-sm btn-outline-secondary" @click="resetFilters">
            <i class="fas fa-times me-1"></i>
            Effacer
          </button>
        </div>
        <div class="card-body">
          <div class="filter-grid">
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-search me-1"></i>
                Recherche générale
              </label>
              <div class="search-input-wrapper">
                <input type="text" class="form-control search-input" placeholder="Rechercher..." v-model="search"
                  @input="filterClients" />
                <i class="fas fa-search search-icon"></i>
              </div>
            </div>
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-calendar-alt me-1"></i>
                Date début
              </label>
              <input type="date" class="form-control" v-model="filters.startDate" @change="applyFilters" />
            </div>
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-calendar-alt me-1"></i>
                Date fin
              </label>
              <input type="date" class="form-control" v-model="filters.endDate" @change="applyFilters" />
            </div>
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-user-tie me-1"></i>
                Filtrer par comptable
              </label>
              <select v-model="filters.selectedComptable" @change="applyFilters" class="form-select">
                <option value="">Tous les comptables</option>
                <option v-for="comptable in uniqueComptables" :key="comptable" :value="comptable">
                  {{ comptable }}
                </option>
              </select>
            </div>
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-clock me-1"></i>
                Filtrer par période
              </label>
              <select v-model="filters.selectedPeriode" @change="applyFilters" class="form-select">
                <option value="">Toutes les périodes</option>
                <option v-for="periode in uniquePeriodes" :key="periode" :value="periode">
                  {{ periode }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Enhanced Data Table Card -->
      <div class="card data-table-card">
        <div class="card-body">
          <!-- Table Section with Horizontal Scroll -->
          <div class="table-container">
            <div class="table-responsive">
              <table class="table table-hover table-striped mb-0 modern-table">
                <thead>
                  <tr>
                    <th @click="sortBy('ice')" class="sortable">
                      ICE <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('nom_societe')" class="sortable">
                      Nom de la société <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('gerant')" class="sortable">
                      Gérant <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('tel_gerant')" class="sortable">
                      N° TEL Gérant <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('email')" class="sortable">
                      Email <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('periode')" class="sortable">
                      Période <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('date_debut')" class="sortable">
                      Date début <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('date_fin')" class="sortable">
                      Date de fin <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('montant')" class="sortable">
                      Montant <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('comptable')" class="sortable">
                      Comptable <i class="fas fa-sort"></i>
                    </th>
                    <th @click="sortBy('numero_comptable')" class="sortable">
                      N° TEL comptable <i class="fas fa-sort"></i>
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="record in filteredData" :key="record.id">
                    <td>
                      <div class="text-nowrap">
                        <span class="fw-semibold">{{ record.ice }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap">
                        <span class="fw-semibold">{{ record.nom_societe }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap">{{ record.gerant }}</div>
                    </td>
                    <td>
                      <div class="text-nowrap phone-cell">
                        <a :href="`tel:${record.tel_gerant}`" class="text-success">
                          {{ record.tel_gerant }}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap email-cell">
                        <a :href="`mailto:${record.email}`" class="text-primary">
                          {{ record.email }}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap">
                        <span class="badge bg-info text-white">{{ record.periode }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap">{{ formatDate(record.date_debut) }}</div>
                    </td>
                    <td>
                      <div class="text-nowrap">{{ formatDate(record.date_fin) }}</div>
                    </td>
                    <td>
                      <div class="text-nowrap">
                        <span class="fw-semibold text-success">{{ formatCurrency(record.montant) }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-nowrap">
                        <span class="badge bg-secondary">{{ record.comptable }}</span>
                      </div>
                    </td>
                    <td>
                      <a :href="`tel:${record.numero_comptable}`" class="text-success">
                        {{ record.numero_comptable }}
                      </a>
                    </td>
                    <td>
                      <div class="action-buttons">
                        <router-link :to="`/clients/${record.id}`" class="action-btn view-action"
                          title="Voir les détails">
                          <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link :to="{ name: 'EditClient', params: { id: record.id } }"
                          class="action-btn edit-action" title="Modifier">
                          <i class="fas fa-edit"></i>
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Enhanced Pagination -->
          <div class="pagination-wrapper">
            <div class="pagination-info">
              <div class="entries-selector">
                <label class="entries-label">Afficher :</label>
                <select v-model="pageSize" class="form-select entries-select" @change="onPageSizeChange">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="entries-text">entrées par page</span>
              </div>
              <div class="records-info">
                <span class="records-text">
                  Affichage de <strong>{{ startRecord }}</strong> à <strong>{{ endRecord }}</strong>
                  sur <strong>{{ allFilteredData.length }}</strong> clients
                </span>
              </div>
            </div>
            <div class="pagination-controls">
              <button class="pagination-btn first-btn" :disabled="currentPage === 1" @click="goToPage(1)">
                <i class="fas fa-angle-double-left"></i>
              </button>
              <button class="pagination-btn prev-btn" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                <i class="fas fa-angle-left"></i>
              </button>
              <div class="page-selector">
                <span class="page-text">Page :</span>
                <select v-model="currentPage" class="form-select page-select" @change="onPageChange">
                  <option v-for="page in totalPages" :key="page" :value="page">{{ page }}</option>
                </select>
                <span class="page-total">sur {{ totalPages }}</span>
              </div>
              <button class="pagination-btn next-btn" :disabled="currentPage === totalPages"
                @click="goToPage(currentPage + 1)">
                <i class="fas fa-angle-right"></i>
              </button>
              <button class="pagination-btn last-btn" :disabled="currentPage === totalPages"
                @click="goToPage(totalPages)">
                <i class="fas fa-angle-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <clients-modal ref="clientsModal" @client-added="onClientAdded" @client-edited="fetchClients"></clients-modal>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { ref } from 'vue';

export default {
  data() {
    return {
      allClients: [],
      search: "",
      pageSize: 10,
      currentPage: 1,
      sortField: '',
      sortDirection: 'asc',
      filters: {
        startDate: "",
        endDate: "",
        selectedComptable: "",
        selectedPeriode: "",
      },
      companyInfo: ref(null),
    };
  },
  computed: {
    filteredData() {
      let filtered = [...this.allClients];
      
      // General search filter
      const s = this.search.toLowerCase().trim();
      if (s) {
        filtered = filtered.filter(
          (c) =>
            (c.ice && c.ice.toLowerCase().includes(s)) ||
            (c.nom_societe && c.nom_societe.toLowerCase().includes(s)) ||
            (c.gerant && c.gerant.toLowerCase().includes(s)) ||
            (c.tel_gerant && c.tel_gerant.toLowerCase().includes(s)) ||
            (c.email && c.email.toLowerCase().includes(s)) ||
            (c.periode && c.periode.toLowerCase().includes(s)) ||
            (c.comptable && c.comptable.toLowerCase().includes(s)) ||
            (c.numero_comptable && c.numero_comptable.toLowerCase().includes(s))
        );
      }

      // Date range filter
      if (this.filters.startDate) {
        filtered = filtered.filter(c => {
          const clientDate = new Date(c.date_debut);
          const startDate = new Date(this.filters.startDate);
          return clientDate >= startDate;
        });
      }
      if (this.filters.endDate) {
        filtered = filtered.filter(c => {
          const clientDate = new Date(c.date_fin);
          const endDate = new Date(this.filters.endDate);
          return clientDate <= endDate;
        });
      }

      // Comptable filter
      if (this.filters.selectedComptable) {
        filtered = filtered.filter(c =>
          c.comptable && c.comptable === this.filters.selectedComptable
        );
      }

      // Période filter
      if (this.filters.selectedPeriode) {
        filtered = filtered.filter(c =>
          c.periode && c.periode === this.filters.selectedPeriode
        );
      }

      // Sorting
      if (this.sortField) {
        filtered.sort((a, b) => {
          let aVal = a[this.sortField] || '';
          let bVal = b[this.sortField] || '';
          
          if (this.sortField === 'montant') {
            aVal = parseFloat(aVal) || 0;
            bVal = parseFloat(bVal) || 0;
          } else if (this.sortField === 'date_debut' || this.sortField === 'date_fin') {
            aVal = new Date(aVal);
            bVal = new Date(bVal);
          } else {
            aVal = aVal.toString().toLowerCase();
            bVal = bVal.toString().toLowerCase();
          }
          
          if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
          if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
          return 0;
        });
      }

      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return filtered.slice(start, end);
    },
    allFilteredData() {
      let filtered = [...this.allClients];
      
      // Apply same filters as filteredData but without pagination
      const s = this.search.toLowerCase().trim();
      if (s) {
        filtered = filtered.filter(
          (c) =>
            (c.ice && c.ice.toLowerCase().includes(s)) ||
            (c.nom_societe && c.nom_societe.toLowerCase().includes(s)) ||
            (c.gerant && c.gerant.toLowerCase().includes(s)) ||
            (c.tel_gerant && c.tel_gerant.toLowerCase().includes(s)) ||
            (c.email && c.email.toLowerCase().includes(s)) ||
            (c.periode && c.periode.toLowerCase().includes(s)) ||
            (c.comptable && c.comptable.toLowerCase().includes(s)) ||
            (c.numero_comptable && c.numero_comptable.toLowerCase().includes(s))
        );
      }

      if (this.filters.startDate) {
        filtered = filtered.filter(c => {
          const clientDate = new Date(c.date_debut);
          const startDate = new Date(this.filters.startDate);
          return clientDate >= startDate;
        });
      }
      if (this.filters.endDate) {
        filtered = filtered.filter(c => {
          const clientDate = new Date(c.date_fin);
          const endDate = new Date(this.filters.endDate);
          return clientDate <= endDate;
        });
      }

      if (this.filters.selectedComptable) {
        filtered = filtered.filter(c =>
          c.comptable && c.comptable === this.filters.selectedComptable
        );
      }

      if (this.filters.selectedPeriode) {
        filtered = filtered.filter(c =>
          c.periode && c.periode === this.filters.selectedPeriode
        );
      }

      return filtered;
    },
    totalPages() {
      return Math.ceil(this.allFilteredData.length / this.pageSize) || 1;
    },
    startRecord() {
      if (this.allFilteredData.length === 0) return 0;
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endRecord() {
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.allFilteredData.length);
    },
    uniqueComptables() {
      const comptables = this.allClients
        .map(client => client.comptable.trim())
        .filter(name => name !== "")
        .filter((name, index, self) => self.indexOf(name) === index)
        .sort();
      return comptables;
    },
    uniquePeriodes() {
      const periodes = this.allClients
        .map(client => client.periode)
        .filter(periode => periode && periode.trim() !== '')
        .filter((periode, index, array) => array.indexOf(periode) === index)
        .sort();
      return periodes;
    },
  },
  methods: {
    // Get image URL for Laravel Storage
    getImageUrl(path) {
      if (!path) return null;
      return `${process.env.VUE_APP_API_URL}/storage/${path}`;
    },
    sortBy(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('fr-FR');
    },
    formatCurrency(amount) {
      if (!amount) return '0 DH';
      return new Intl.NumberFormat('fr-MA', {
        style: 'currency',
        currency: 'MAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount).replace('MAD', 'DH');
    },
    onPageSizeChange() {
      this.currentPage = 1;
    },
    onPageChange() {
      // La page est automatiquement mise à jour via v-model
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    applyFilters() {
      this.currentPage = 1;
    },
    resetFilters() {
      this.filters = {
        startDate: "",
        endDate: "",
        selectedComptable: "",
        selectedPeriode: "",
      };
      this.search = "";
      this.currentPage = 1;
      this.sortField = '';
      this.sortDirection = 'asc';
    },
    filterClients() {
      this.currentPage = 1;
    },
    exportToExcel() {
      const dataToExport = this.allFilteredData.map((client) => ({
        "N° ICE": client.ice,
        "Nom de la société": client.nom_societe,
        "Gérant": client.gerant,
        "N° TEL Gérant": client.tel_gerant,
        "Email": client.email,
        "Période": client.periode,
        "Date début": this.formatDate(client.date_debut),
        "Date de fin": this.formatDate(client.date_fin),
        "Montant": client.montant,
        "Comptable": client.comptable,
        "N° TEL comptable": client.numero_comptable,
      }));

      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        data,
        `clients_${new Date().toISOString().split("T")[0]}.xlsx`
      );
      
      this.showSuccessMessage("Export Excel réussi!");
    },
    exportToCSV() {
      const headers = [
        "N° ICE",
        "Nom de la société", 
        "Gérant",
        "N° TEL Gérant",
        "Email",
        "Période",
        "Date début",
        "Date de fin",
        "Montant",
        "Comptable",
        "N° TEL comptable"
      ];

      const csvContent = [
        headers.join(','),
        ...this.allFilteredData.map(client => [
          `"${client.ice || ''}"`,
          `"${client.nom_societe || ''}"`,
          `"${client.gerant || ''}"`,
          `"${client.tel_gerant || ''}"`,
          `"${client.email || ''}"`,
          `"${client.periode || ''}"`,
          `"${this.formatDate(client.date_debut)}"`,
          `"${this.formatDate(client.date_fin)}"`,
          `"${client.montant || 0}"`,
          `"${client.comptable || ''}"`,
          `"${client.numero_comptable || ''}"`
        ].join(','))
      ].join('\n');

      // Add UTF-8 BOM for proper French accent support
      const BOM = '\uFEFF';
      const csvWithBOM = BOM + csvContent;
      
      const blob = new Blob([csvWithBOM], { 
        type: 'text/csv;charset=utf-8;' 
      });
      saveAs(blob, `clients_${new Date().toISOString().split("T")[0]}.csv`);
      
      this.showSuccessMessage("Export CSV réussi!");
    },
    exportToPDF() {
  if (!this.allFilteredData.length) {
    this.showErrorMessage("Aucune donnée à exporter");
    return;
  }

  // Create the HTML content for printing
  const printContent = `<!DOCTYPE html>
<html>
  <head>
    <title></title>
    <meta charset="UTF-8">
    <style>
      @page {
        size: auto;
        margin: 10mm;
      }
            
      @media print {
        html, body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
                
        body {
          margin: 0;
          padding: 0;
        }
                
        .no-print {
          display: none !important;
        }
                
        @page {
          margin: 0;
        }
                
        @page :first {
          margin-top: 0;
        }
                
        @page :left {
          margin-left: 0;
        }
                
        @page :right {
          margin-right: 0;
        }
      }
            
      body {
        font-family: Arial, sans-serif;
        margin: 20px;
        font-size: 11px;
        line-height: 1.3;
      }
      .header {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        border-bottom: 2px solid #ddd;
        padding-bottom: 15px;
      }
      .company-logo {
        width: 80px;
        height: 80px;
        margin-right: 20px;
        border-radius: 0px;
        object-fit: contain;
      }
      .header-content {
        flex: 1;
      }
      .client-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
        text-align: left;
        color: #2c3e50;
      }
      .print-date {
        font-size: 11px;
        color: #666;
        text-align: left;
      }
      .table-container {
        margin-bottom: 20px;
      }
      .clients-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        font-size: 10px;
      }
      .clients-table th {
        background-color: #255EFF;
        color: white;
        padding: 8px 6px;
        text-align: left;
        font-weight: bold;
        border: 1px solid #ddd;
        font-size: 9px;
      }
      .clients-table td {
        padding: 6px 4px;
        border: 1px solid #ddd;
        vertical-align: top;
        font-size: 9px;
      }
      .clients-table tbody tr:nth-child(even) {
        background-color: #f8f9fa;
      }
      .clients-table tbody tr:hover {
        background-color: #e9ecef;
      }
      .badge {
        display: inline-block;
        padding: 2px 6px;
        border-radius: 0px;
        font-size: 8px;
        font-weight: bold;
      }
      .bg-success {
        background-color: #28a745;
        color: white;
      }
      .bg-danger {
        background-color: #dc3545;
        color: white;
      }
      .bg-warning {
        background-color: #ffc107;
        color: #212529;
      }
      .bg-primary {
        background-color: #007bff;
        color: white;
      }
      .bg-secondary {
        background-color: #6c757d;
        color: white;
      }
      .bg-info {
        background-color: #17a2b8;
        color: white;
      }
      .bg-light {
        background-color: #f8f9fa;
        color: #212529;
        border: 1px solid #dee2e6;
      }
      .text-success {
        color: #28a745;
        font-weight: 600;
      }
      .footer {
        margin-top: 40px;
        padding-top: 20px;
        border-top: 1px solid #ddd;
      }
      .company-signature {
        text-align: center;
        font-family: Arial, sans-serif;
        font-size: 10px;
        color: #000;
        font-weight: normal;
        line-height: 1.4;
      }
      .no-print {
        margin-top: 30px;
        text-align: center;
      }
      .print-btn {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 10px 20px;
        margin: 0 5px;
        border-radius: 0px;
        cursor: pointer;
        font-size: 12px;
      }
      .print-btn:hover {
        background-color: #0056b3;
      }
      .close-btn {
        background-color: #6c757d;
        color: white;
        border: none;
        padding: 10px 20px;
        margin: 0 5px;
        border-radius: 0px;
        cursor: pointer;
        font-size: 12px;
      }
      .close-btn:hover {
        background-color: #545b62;
      }
      .text-nowrap {
        white-space: nowrap;
      }
      .fw-semibold {
        font-weight: 600;
      }
    </style>
  </head>
  <body>
    <div class="header">
      ${this.companyInfo?.logo ? `<img src="${this.getImageUrl(this.companyInfo.logo)}" alt="Logo" class="company-logo" />` : '<div class="company-logo" style="background-color: #255EFF; display: flex; align-items: center; justify-content: center; font-size: 12px; color: white; border-radius: 0px;">LOGO</div>'}
      <div class="header-content">
        <div class="print-date">Date d'export: ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR')}</div>
      </div>
    </div>
        
    <div class="table-container">
      <table class="clients-table">
        <thead>
          <tr>
            <th style="width: 8%;">ICE</th>
            <th style="width: 15%;">Société</th>
            <th style="width: 12%;">Gérant</th>
            <th style="width: 10%;">Tél Gérant</th>
            <th style="width: 15%;">Email</th>
            <th style="width: 8%;">Période</th>
            <th style="width: 8%;">Date début</th>
            <th style="width: 8%;">Date fin</th>
            <th style="width: 8%;">Montant</th>
            <th style="width: 10%;">Comptable</th>
            <th style="width: 8%;">Tél Comptable</th>
          </tr>
        </thead>
        <tbody>
          ${this.allFilteredData.map(client => `
            <tr>
              <td class="text-nowrap">${client.ice || '-'}</td>
              <td class="fw-semibold">${client.nom_societe || '-'}</td>
              <td>${client.gerant || '-'}</td>
              <td class="text-nowrap">${client.tel_gerant || '-'}</td>
              <td style="font-size: 8px;">${client.email || '-'}</td>
              <td><span>${client.periode || '-'}</span></td>
              <td class="text-nowrap">${this.formatDate(client.date_debut)}</td>
              <td class="text-nowrap">${this.formatDate(client.date_fin)}</td>
              <td class="text-success fw-semibold">${this.formatCurrency(client.montant)}</td>
              <td><span style="font-size: 7px;">${client.comptable || '-'}</span></td>
              <td><span style="font-size: 7px;">${client.numero_comptable || '-'}</span></td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </div>
        
    <div class="footer">
      <div class="company-signature">
        ${this.companyInfo ? `
          TEL: ${this.companyInfo.telephone || 'N/A'} SIEGE SOCIAL: ${this.companyInfo.adresse || 'N/A'}
          <br>
          RC: ${this.companyInfo.rc || 'N/A'} - IF: ${this.companyInfo.identifiant_fiscal || 'N/A'} - TP: ${this.companyInfo.tp || 'N/A'} - ICE: ${this.companyInfo.ice || 'N/A'}
        ` : `
          GESTION DES CLIENTS - RAPPORT GÉNÉRÉ LE ${new Date().toLocaleDateString('fr-FR').toUpperCase()}
        `}
      </div>
    </div>
        
    <div class="no-print">
      <button onclick="window.print()" class="print-btn">
        Imprimer
      </button>
      <button onclick="window.close()" class="close-btn">
        Fermer
      </button>
    </div>
        
    <script>
      window.onload = function() {
        document.title = "";
      }
    <\/script>
  </body>
</html>`;

  // Create a new print window
  const printWindow = window.open("", "_blank", "width=1200,height=800");
  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    // Wait for content to load
    printWindow.onload = function () {
      printWindow.focus();
      // Set empty title to avoid showing URL
      printWindow.document.title = "";
    };
    
    this.showSuccessMessage("Fenêtre d'impression ouverte!");
  } else {
    // Fallback if popup is blocked
    Swal.fire({
      icon: "warning",
      title: "Popup bloquée",
      text: "Veuillez autoriser les popups pour imprimer le document.",
      confirmButtonText: "OK"
    });
  }
},
    // Fetch company information
    async fetchCompanyInfo() {
      try {
        const response = await axios.get('/societes');
        //console.log("Réponse API société brute:", response);
        if (response.data) {
          this.companyInfo = {
            nom: response.data.nom_francais,
            adresse: response.data.adresse_siege_social_francais,
            telephone: response.data.telephone,
            email: response.data.email,
            site_web: response.data.website || response.data.site_web || response.data.url,
            logo: response.data.logo || response.data.logo_path,
            rc: response.data.rc,
            identifiant_fiscal: response.data.identifiant_fiscal,
            tp: response.data.tp,
            ice: response.data.ice
          };
        } else {
          this.companyInfo = null;
        }
      } catch (err) {
        this.companyInfo = null;
        if (err.response && err.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session expirée',
            text: 'Vous allez être déconnecté.',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            if (this.$router) {
              this.$router.push({ name: "logout" });
            } else {
              window.location.href = '/logout';
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la récupération des informations de la société.',
            timer: 2000,
            showConfirmButton: false
          });
        }
      }
    },
    async fetchClients() {
      try {
        const response = await axios.get("/clients2");
        //console.log("Clients fetched successfully:", response.data);
        this.allClients = response.data.map((c) => {
          const dateDebut = new Date(c.domiciliation?.date_debut || c.bureau?.date_debut);
          const dateFin = new Date(c.domiciliation?.date_fin || c.bureau?.date_fin);
          let periode = "";
          if (!isNaN(dateDebut) && !isNaN(dateFin)) {
            const diffTime = Math.abs(dateFin - dateDebut);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            const years = Math.floor(diffDays / 365);
            const months = Math.floor((diffDays % 365) / 30);
            if (years > 0) periode += `${years} an${years > 1 ? "s" : ""}`;
            if (months > 0) periode += (periode ? " " : "") + `${months} mois`;
            if (!periode) periode = `${diffDays} jours`;
          }

          return {
            id: c.id,
            ice: c.ice || "",
            nom_societe: c.nom_francais || "",
            gerant: c.gerant?.nom || "",
            tel_gerant: c.gerant?.telephone || "Aucun",
            email: c.email || "",
            periode,
            date_debut: c.domiciliation?.date_debut || c.bureau?.date_debut || "",
            date_fin: c.domiciliation?.date_fin || c.bureau?.date_fin || "",
            montant: c.domiciliation?.montant || c.bureau?.montant || 0,
            comptable: `${c.comptable?.nom_francais || ""}`.trim(),
            numero_comptable: c.comptable?.telephone || "",
          };
        });
        await this.fetchCompanyInfo();
      } catch (error) {
        this.handleApiError(error);
      }
    },
    showSuccessMessage(message) {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: message,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    },
    showErrorMessage(message) {
      Swal.fire({
        icon: "error",
        title: "Erreur!",
        text: message,
        confirmButtonText: "OK",
      });
    },
    handleApiError(error) {
      if (error.response) {
        const errorMessage = error.response.data.error || error.response.data.details || "Erreur lors de l'opération";
        if (error.response.status === 401) {
          this.showErrorMessage("Session expirée. Veuillez vous reconnecter.");
          setTimeout(() => {
            if (this.$router) {
              this.$router.push({ name: "logout" });
            } else {
              window.location.href = '/logout';
            }
          }, 1500);
        } else if (error.response.status === 422) {
          const validationErrors = error.response.data.errors;
          const errorMessages = Object.values(validationErrors).flat();
          this.showErrorMessage(errorMessages.join("\n"));
        } else {
          this.showErrorMessage(errorMessage);
        }
      } else {
        this.showErrorMessage("Erreur de connexion au serveur");
      }
    },
    onClientAdded() {
      this.fetchClients();
      this.showSuccessMessage("Client créé avec succès");
    },
  },
  async mounted() {
    this.fetchClients();
  },
};
</script>

<style scoped>
/* ==================== Modern Header Styles ==================== */
.modern-header {
  background: #255EFF !important;
  border-radius: 0px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  color: white;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.page-title-section {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.title-content h4 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
}

.page-subtitle {
  margin: 0.25rem 0 0 0;
  opacity: 0.9;
  font-size: 0.95rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.export-actions {
  display: flex;
  gap: 0.5rem;
  margin-right: 1rem;
}

.export-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.export-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.btn-added {
  background: rgba(255, 255, 255, 0.9);
  color: #255EFF;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0px;
  font-weight: 600;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-added:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: #255EFF;
}

/* ==================== Filter Card Styles ==================== */
.filter-card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  overflow: hidden;
}

.filter-card .card-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.search-input-wrapper {
  position: relative;
}

.search-input {
  padding-right: 2.5rem;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.search-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.form-control,
.form-select {
  border-radius: 0px;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

/* ==================== Data Table Card Styles ==================== */
.data-table-card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.table-container {
  background: white;
}

/* ==================== Table Styles ==================== */
.modern-table {
  margin: 0;
}

.modern-table thead th {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  padding: 1rem 0.75rem;
  font-size: 0.875rem;
  position: relative;
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sortable:hover {
  background: linear-gradient(135deg, #e9ecef, #dee2e6);
}

.sortable i {
  margin-left: 0.5rem;
  opacity: 0.5;
}

.modern-table tbody tr {
  transition: all 0.3s ease;
}

.modern-table tbody tr:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-name-cell {
  font-weight: 600;
}

.email-cell a {
  text-decoration: none;
}

.email-cell a:hover {
  text-decoration: underline;
}

.phone-cell a {
  text-decoration: none;
}

.phone-cell a:hover {
  text-decoration: underline;
}

.address-cell {
  max-width: 200px;
  word-wrap: break-word;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 0.875rem;
  text-decoration: none;
}

.view-action {
  background: linear-gradient(135deg, #255EFF, #255EFF);
  color: white;
}

.view-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
  color: white;
}

.edit-action {
  background: linear-gradient(135deg, #255EFF, #255EFF);
  color: white;
}

.edit-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  color: white;
}

/* ==================== Pagination Styles ==================== */
.pagination-wrapper {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.pagination-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.entries-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.entries-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
}

.entries-select {
  width: auto;
  min-width: 80px;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  padding: 0.375rem 0.75rem;
}

.entries-text {
  color: #6c757d;
  font-size: 0.875rem;
}

.records-info {
  display: flex;
  align-items: center;
}

.records-text {
  color: #495057;
  font-size: 0.875rem;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.pagination-btn {
  width: 40px;
  height: 40px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.pagination-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-color: #667eea;
  color: white;
  transform: translateY(-2px);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  margin: 0 1rem;
}

.page-text,
.page-total {
  color: #6c757d;
  font-size: 0.875rem;
}

.page-select {
  width: 70px;
  border: 1px solid #dee2e6;
  border-radius: 0px;
  padding: 0.25rem 0.5rem;
  text-align: center;
}

/* ==================== Responsive Design ==================== */
@media (max-width: 1200px) {
  .filter-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .modern-header {
    padding: 1.5rem;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
  }

  .page-title-section {
    flex-direction: column;
    gap: 1rem;
  }

  .title-wrapper {
    flex-direction: column;
    text-align: center;
  }

  .header-actions {
    flex-direction: column;
    gap: 1rem;
  }

  .export-actions {
    justify-content: center;
    margin-right: 0;
  }

  .filter-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .pagination-info {
    flex-direction: column;
    gap: 1rem;
  }

  .pagination-controls {
    flex-wrap: wrap;
  }

  .page-selector {
    margin: 0;
  }
}

@media (max-width: 576px) {
  .modern-header {
    padding: 1rem;
  }

  .icon-wrapper {
    width: 50px;
    height: 50px;
    font-size: 1.25rem;
  }

  .title-content h4 {
    font-size: 1.5rem;
  }

  .export-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.25rem;
  }

  .address-cell {
    max-width: 100%;
  }
}

/* Badge styles */
.badge {
  padding: 4px 8px;
  border-radius: 0px;
  font-size: 0.75rem;
  font-weight: 500;
}

.bg-light {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
}

.bg-success {
  background-color: #28a745 !important;
  color: white !important;
}

.bg-danger {
  background-color: #dc3545 !important;
  color: white !important;
}

.bg-primary {
  background-color: #007bff !important;
  color: white !important;
}

.bg-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}

.bg-info {
  background-color: #17a2b8 !important;
  color: white !important;
}

.bg-secondary {
  background-color: #6c757d !important;
  color: white !important;
}

.text-nowrap {
  white-space: nowrap;
}

.fw-semibold {
  font-weight: 600;
}

.text-success {
  color: #28a745 !important;
}

.text-primary {
  color: #007bff !important;
}

.me-1 {
  margin-right: 0.25rem;
}

.me-2 {
  margin-right: 0.5rem;
}

.mb-0 {
  margin-bottom: 0;
}

.table-responsive {
  scrollbar-width: thin;
  /* "auto" or "thin" */
  scrollbar-color: #255EFF white;
  /* thumb color track color */
}
</style>
